<template>
	<div class="erji-title">
		<h1 class="fl">{{titleName}}</h1>
		<div class="mianbaoxie fr visible-lg-block">
			<i>首页</i> > <i>{{fatherName}}</i> > <span>{{titleName}}</span>
		</div>
		<div class="clear"></div>
	</div>
</template>

<script>
	export default {
	  name: 'erjiTitle',
		props: ['titleName','fatherName'],
		data(){
			return{
				
			}
		},
		methods:{
			goHome(){
				this.$router.push({
					path:'/',
					query:{
						// category_id:item.category_id,
						// id:item.id
					}
				})	 
			},
			goCategory(){
				this.$router.push({
					path:'/home',
					query:{
						// category_id:item.category_id,
						// id:item.id
					}
				})	 
			}
		}
	}
</script>

<style>
</style>